<template>
  <div class="search">
    <div class="search-inner">
      <div class="firstChild">Expression Pattern explorer</div>
      <div class="sequence">
        <el-form ref="form1" :inline="false" :model="heatmap_form" label-width="100px">
          <el-form-item label="Species">
            <el-select size="large" v-model="heatmap_form.specie" @change="specieChange" placeholder="Choose">
              <el-option v-for="(item, index) in heatSpacieOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="SRA Study">
            <el-select size="large" clearable v-model="heatmap_form.sra_study" placeholder="Choose">
              <el-option v-for="(item, index) in SRA_StudyOptions" :key="index" :label="item.sra_study" :value="item.sra_study">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="lncRAN ID" class="">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" placeholder="Please input lncRNA ID list，each ID ends with '\n' and number of lncRNA should be less than 1000. If no ID entered, all lncRNAs in the database will be returned."
              v-model="heatmap_form.lncRNA_id" style="width:600px;">
            </el-input>
          </el-form-item>
        </el-form>
        <p class="file_p">
          <a href="javascript:;" class="file">Upload file
            <input type="file" name="file" ref="file" @change="handleUpdate($event)" />
          </a>
          <span>{{fileName}}</span>
        </p>
        <el-row style="margin: 20px 0px 40px 0;">
          <el-button class="btnSearch" @click="Example('heatmap_form')">Example</el-button>
          <el-button class="btnSearch" :loading="goLoading" style="width:auto;" @click="Search('heatmap_form')">Go</el-button>
          <el-button class="btnReset" @click="Reset('heatmap_form')">Reset</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
let url = {
  specie_all: "species/specie_name_heatmap",
  sra_study: "species/specie_study_heatmap",
  blast_data: "blast/blast_data"
};
import bus from '@/components/common/bus.js'
export default {
  data() {
    return {
      heatmap_form: {
        lncRNA_id: "",
        sra_study: "",
        specie: ""
      },
      rules: {
        specie: [
          { required: true, message: 'Please select', trigger: 'change' }
        ]
      },
      SRA_StudyOptions: [],
      heatSpacieOptions: [],
      file: "",
      fileName: '',
      goLoading: false
    };
  },
  mounted() {
    this.specie_all()
  },
  methods: {
    Example(param) {
      let params = "";
      if (param == "heatmap_form") {
        this.heatmap_form = {
          lncRNA_id: "URS0000A7770A_3702.223790\nAt1NC048780\nURS0000A76CF7_3702.120335\nAt4NC049670\nURS0000A770EC_3702.240582\nAt5NC068680\nURS0000A76DF8_3702.296311\nEL0995\nURS0000A7652D_3702.2845\nURS0000A76776_3702.169694\nURS0000A76A85_3702.288690\nURS0000A774A8_3702.227811\nAt3NC030490\nAt2NC009700\nURS0000A77425_3702.222130\nAt5NC038370\nAt2NC048540\nAt1NC033490\nAt5NC035610\nAt5NC021290\nAt5NC057680\nATHA_LNC000354.2\nAt2NC009010\nAt2NC014140\nAt5NC003390\nURS0000A775A3_3702.1488\nATHA_LNC000581.1\nAt1NC096601\nURS0000A77819_3702.56938\nAt2NC040280\nURS0000A775C1_3702.217463\nAt3NC004410\nAt1NC045060\nATHA_LNC000278.57\nAt1NC077820\nURS0000A777CB_3702.298901\nAt3NC008140\nURS0000A76AE0_3702.166337\nAt1NC110540\nAt2NC070320\nAt3NC027300\nURS0000A77621_3702.68227\nAt3NC022530\nATHA_LNC000049.1\nATHA_LNC000359.2\nURS0000A773F9_3702.56720\nURS0000A76523_3702.223211\nAt1NC084610\nAt5NC039530\nATHA_LNC000537.4\nURS0000A770A9_3702.300240\nAt1NC084730\nATHA_LNC000245.1\nAt1NC106320\nATHA_LNC000387.1\nURS0000A777E4_3702.293258\nURS0000A77316_3702.109524\nATHA_LNC000393.2\nATHA_LNC000441.26\nATHA_LNC000479.1\nURS0000A76599_3702.229616\nATHA_LNC000497.1\nURS0000A76771_3702.45744\nURS0000A7764E_3702.106722\nURS0000A76654_3702.133077\nURS0000A766DD_3702.104641\nATHA_LNC000552.2\nAt5NC055340\nURS0000A77272_3702.53908\nURS0000A765B5_3702.106575\nURS0000A77457_3702.46280\nURS0000A77702_3702.2059\nATHA_LNC000699.5\nURS0000A76EA8_3702.99498\nAt5NC023550\nURS0000A76F74_3702.177385\nURS0000A7648D_3702.56179\nURS0000A76FCB_3702.237314\nURS0000A77005_3702.227977\nURS0000A77360_3702.6048\nAt2NC008860\nAt4NC023950\nAt3NC048710\nAt3NC016580\nURS0000A765CE_3702.228800\nAt4NC050760\nAt5NC061480\nAt2NC024470\nATHA_LNC000281.1\nURS0000A76C66_3702.224194\nURS0000A770B0_3702.233281\nAt2NC058220\nURS0000A76FB8_3702.114278\nAt5NC094440\nURS0000A77737_3702.54078\nURS0000A76799_3702.108913\nATHA_LNC000745.1\nATHA_LNC000004.1\nURS0000A7662E_3702.299815\nATHA_LNC000456.1",
          sra_study: "SRP163044",
          specie: "Arabidopsis_thaliana"
        };
      }
    },
    specie_all() {
      this.http.get(url.specie_all, {}).then((res) => {
        if (res.data.code == 200) {
          this.heatSpacieOptions = res.data.data;
          this.heatmap_form.specie = res.data.data[0].value
          this.sra_study()
        }
      }).catch((err) => {
        this.$message.warning(err.response.data.error.message);
      });
    },
    Search(param) {
      if (this.heatmap_form.lncRNA_id.split('\n').length > 1000) {
        this.$message('The data is too long and does not meet the matching requirements！')
        return
      }
      sessionStorage.removeItem("heatmapParams");
      let tableParams = Object.assign({}, this.heatmap_form, {
        file: JSON.stringify(this.file)
      })
      sessionStorage.setItem("heatmapParams", JSON.stringify(tableParams));
      // this.$router.push("/EPexplorerResult");
      this.getData()
    },
    getData() {
      let lncRNA_ids = []
      this.heatmap_form.lncRNA_id.split('\n').forEach(item => {
        if (item != '') {
          lncRNA_ids.push(item.trim())
        }
      })
      let formData = new FormData()
      formData.append('specie', this.heatmap_form.specie)
      formData.append('sra_study', this.heatmap_form.sra_study == 'All SRA' ? '' : this.heatmap_form.sra_study)
      formData.append('file', this.file)
      formData.append('lncRNA_id', lncRNA_ids.join(','))
      formData.append('page', 1)
      formData.append('size', 10)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      sessionStorage.removeItem("heatmapData");
      this.goLoading = true
      this.$axios.post('species/tool_theatmap_specie_sra_study/', formData, config).then(res => {
        if (res.data.code == 200) {
          sessionStorage.setItem("heatmapData", JSON.stringify(res.data));
          this.goLoading = false
          this.$router.push("/EPexplorerResult");
        } else {
          this.$message.warning(res.data.msg);
        }
      }).catch(err => {
        this.$message.warning(err.data.msg);
      });
    },
    Reset(param) {
      if (param == "heatmap_form") {
        this.fileName = ''
        this.file = ''
        this.heatmap_form = {
          lncRNA_id: "",
          sra_study: "",
          specie: ""
        }
        this.$refs['form1'].resetFields()
      }
    },
    sra_study() {
      this.heatmap_form.sra_study = ''
      this.SRA_StudyOptions = []
      let params = {
        specie: this.heatmap_form.specie
      }
      this.http.get(url.sra_study, params).then((res) => {
        if (res.data.code == 200) {
          this.SRA_StudyOptions = res.data.data;
          this.SRA_StudyOptions.unshift({ sra_study: 'All SRA' })
          this.heatmap_form.sra_study = 'All SRA'
        }
      }).catch((err) => {
        this.$message.warning(err.response.data.error.message);
      });
    },
    specieChange(val) {
      this.sra_study()
    },
    handleUpdate(event) {
      this.fileName = event.target.files[0].name
      this.file = event.target.files[0]
      sessionStorage.setItem("files", JSON.stringify(event.target.files[0]));
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: #000;
}
ul,
li {
  list-style: none;
}
.search {
  width: 100%;
  padding: 30px 0px;
  background: #f5f9fc;
}
.search .search-inner {
  width: 1240px;
  padding: 0px 20px;
  margin: 0 auto;
  overflow: hidden;
  background: rgba(255, 255, 255, 1);
}
.search .search-inner .firstChild {
  height: 50px;
  line-height: 50px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  /* line-height: 28px;
  padding-top: 30px; */
  border-bottom: 1px solid rgba(215, 217, 219, 1);
}
.search .search-inner .keyword {
  height: auto;
}
.btnSearch {
  width: 126px;
  height: 40px;
  background: rgba(139, 182, 68, 1);
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #fff;
  outline: none;
  border: none;
}
.btnReset {
  width: 126px;
  height: 40px;
  background: #f1f1f1;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333;
  outline: none;
  border: none;
}
.search .search-inner .sequence {
  height: auto;
  margin-top: 30px;
  /* border-top: 1px solid #8bb644; */
}

.file_p {
  margin-top: 0;
  margin-bottom: 30px;
}
.file_p span {
  display: inline-block;
  padding-left: 30px;
}
.file {
  position: relative;
  display: inline-block;
  background: rgba(139, 182, 68, 1);
  border-radius: 4px;
  overflow: hidden;
  color: #fff;
  text-decoration: none;
  text-indent: 0;
  line-height: 30px;
  cursor: pointer;
  width: 100px;
  height: 30px;
  text-align: center;
  top: 8px;
  left: 0px;
}

.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}

.file:hover {
  color: #fff;
  text-decoration: none;
}
</style>
